<template lang="pug">
  .overflow-y-auto.max-height.min-w-sm.p-2.rounded-lg.overflow-hidden.shadow-2xl.absolute.bg-white.z-10.top-0.left-0(v-on-clickaway="close")
    slot
</template>
<script>
export default {
  name: 'util-modal',
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="stylus" scoped>
  .bg-semi-75
    background-color: rgba(0, 0, 0, 0.75)
  .max-height
    max-height: 252px;
</style>



// WEBPACK FOOTER //
// c_util_popover.vue?50d6529e